import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ApplicationFilters,
  DomainFilters,
  ParticipantFilters,
  RemoteDomainFilters,
  RemoteParticipantFilters,
} from 'data';
import { useItemsListManagement } from './items-list-management';
import { loadPaginationState, savePaginationState } from '../helpers/pagination-storage';

export const usePersistedTableState = (
  filters:
    DomainFilters | RemoteDomainFilters | ParticipantFilters | RemoteParticipantFilters | ApplicationFilters | null,
  setFilters?: (value: React.SetStateAction<object>) => void,
) => {
  const location = useLocation();
  const { pathname } = location;

  // Load initial pagination state from localStorage (memoized to avoid recalculation)
  const savedPagination = useMemo(() => loadPaginationState(pathname), [pathname]);

  // Use the existing hook but with persisted initial state
  const {
    sorting,
    setSorting,
    pagination,
    setPagination,
    onFiltersChange,
    onSortingChange,
    globalFilter,
    setGlobalFilter,
  } = useItemsListManagement(filters, setFilters);

  // Override initial pagination if we have saved state
  useEffect(() => {
    if (savedPagination) {
      setPagination(savedPagination);
    }
  }, [pathname]); // Only run when pathname changes

  // Save pagination state to localStorage whenever it changes
  useEffect(() => {
    savePaginationState(pathname, pagination);
  }, [pathname, pagination]);

  return {
    sorting,
    setSorting,
    pagination,
    setPagination,
    onFiltersChange,
    onSortingChange,
    globalFilter,
    setGlobalFilter,
  };
};
